import { cva } from '@/styled-system/css';

export const inputChipCloseStyles = cva({
  base: {
    'display': 'inline-flex',

    '& > [data-c11n-component="CloseButton"]': {
      marginInlineStart: 'micro.default',
      height: 'icon.sm',
      width: 'icon.sm',
      padding: 'Chip.Close.padding',
      boxShadow: {
        _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
      },
      _after: {
        content: '""',
        position: 'absolute',
        height: 'tapArea.mobile.sm',
        minWidth: 'tapArea.mobile.sm',
        width: '100%',
        top: '50%',
        marginTop: 'calc(({sizes.tapArea.mobile.sm} / 2) * -1)',
      },
    },
  },
  variants: {
    disabled: {
      true: {
        '& > [data-c11n-component="CloseButton"]': {
          opacity: 1,
        },
      },
      false: {
        '& > [data-c11n-component="CloseButton"]': {
          backgroundColor: {
            _hover: 'CloseButton.bg.hover',
            _active: 'CloseButton.bg.pressed',
          },
        },
      },
    },
  },
});
